<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'ORDER_DETAILS.QINETIC_POSITION_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-qinetic-position__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'ORDERS.ID_QP_LABEL'"
      [content]="order?.qinetic_position_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.POSITION_ID_LABEL'"
      [content]="order?.position_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.LIQUIDATION_COLUMN_LABEL'"
      [content]="(order?.liquidated_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.END_DATE_COLUMN_LABEL'"
      [content]="(order?.end_date | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.FEE_COLUMN_LABEL'"
      [content]="getFormattedFee(order)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.NET_COLUMN_LABEL'"
      [content]="getFormattedNet(order)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
